<template>
  <div>
    <el-menu
      class="side-menu"
      :default-active="getActiveComponent"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item
        v-for="link in menuLinks"
        :key="link.name"
        :index="link.name"
        class="flex align-center"
        :disabled="link.disabled"
        :class="[{'hide-translator': isTranslator && !link.translator}, {'hide-turkish': isTurkish && !link.turkish}]"
        @click="menuNavigation(link.path)"
      >
        <i :class="link.icon" />
        {{ link.title }}
      </el-menu-item>

      <a
        target="_blank"
        href="https://cms.owiwi.co.uk/admin"
      >
        <el-menu-item class="flex align-center hide-translator hide-turkish">
          <i class="el-icon-document" />
          CMS <i class="el-icon-top-right" />
        </el-menu-item>
      </a>

      <a
        target="_blank"
        href="https://analytics.owiwi.co.uk/"
      >
        <el-menu-item class="flex align-center hide-translator hide-turkish">
          <i class="el-icon-s-data" />
          Legacy Analytics <i class="el-icon-top-right" />
        </el-menu-item>
      </a>

      <el-menu-item
        class="flex align-center"
        @click="logout()"
      >
        <i class="el-icon-circle-close" />
        Logout
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  computed: {
    menuLinks() {
      return require('@/config/menuLinks.js').default
    },
    isTranslator() {
      return  this.$store.getters.isTranslator
    },
    isTurkish() {
      return  this.$store.getters.isTurkish
    }
  },
  methods: {
    menuNavigation(path) {
      this.$router.replace(path)
    },

    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
  .side-menu {
    width: 220px;
    height: 100%;
  }

  .hide-translator {
    display: none;
  }

  .hide-turkish {
    display: none;
  }
</style>
